export default __webpack_public_path__ + "static/survey-eade77140b112b43761f08b366cbfa54.png";